<template>
  <div ref="chartdiv" style="width: 100%; height: 200px"></div>
</template>

<script>
import * as am4core from '@amcharts/amcharts4/core'
import * as am4maps from '@amcharts/amcharts4/maps'
import am4geodataUsaLow from '@amcharts/amcharts4-geodata/usaLow'
import am4themesAnimated from '@amcharts/amcharts4/themes/animated'

am4core.useTheme(am4themesAnimated)

export default {
  name: 'UsaMapChart',
  data () {
    return {
      chart: null
    }
  },
  props: ['codes', 'retailerImage'],
  watch: {
    codes (oldVal, newVal) {
      console.log('selectedStates changed:', oldVal, newVal)
      console.log(this.selectedStates)
      this.updateMapData()
    }
  },
  updated () {
    this.updateMapData()
  },
  mounted () {
    this.updateMapData()
  },
  methods: {
    updateMapData () {
      console.log(this.codes)
      const chart = am4core.create(this.$refs.chartdiv, am4maps.MapChart)
      chart.geodata = am4geodataUsaLow
      chart.projection = new am4maps.projections.AlbersUsa()

      const polygonSeries = chart.series.push(new am4maps.MapPolygonSeries())
      polygonSeries.useGeodata = true
      console.log(this.selectedStates)
      polygonSeries.data = this.codes

      polygonSeries.heatRules.push({
        target: polygonSeries.mapPolygons.template,
        property: 'fill',
        min: am4core.color('#E5F5F9'),
        max: am4core.color('#2CA25F')
      })

      const polygonTemplate = polygonSeries.mapPolygons.template
      // polygonTemplate.tooltipText = "{name}";
      if (this.retailerImage) {
        polygonTemplate.tooltipHTML = `
        <div style="text-align: center;">
          <img src="` + this.retailerImage + `" width="50" height="50" style="margin-top: 5px;" />
        </div>`
      }

      polygonTemplate.nonScalingStroke = true
      polygonTemplate.strokeWidth = 0.5
      polygonTemplate.stroke = am4core.color('#000')
      polygonTemplate.fill = am4core.color('#eee')

      this.chart = chart
    }
  }
}
</script>
